import { Store } from '@tanstack/store';

export interface TokensState {
  accessToken: string | null;
}

export const TokensStore = new Store<TokensState>({ accessToken: null });

export const setTokens = (accessToken: string, refreshToken: string) => {
  if (!accessToken || !refreshToken) {
    return;
  }

  TokensStore.setState(() => ({ accessToken: accessToken }));
  localStorage.setItem('refreshToken', refreshToken);
};

export const setAccessToken = (accessToken: string) => {
  TokensStore.setState(() => ({ accessToken: accessToken }));
};

export const saveRefreshToken = (refreshToken: string) => {
  if (!refreshToken) return;
  localStorage.setItem('refreshToken', refreshToken);
};

export const clearAccessToken = () => {
  TokensStore.setState(() => ({ accessToken: null }));
};

export const clearRefreshToken = () => {
  localStorage.removeItem('refreshToken');
};

export const getStoredRefreshToken = (): string | null => {
  if (typeof window === 'undefined') return null;

  return localStorage.getItem('refreshToken');
};
